/* IRON LIGHT V12: editorial motion. 3D-inspired choreography using approved still garment views. */
(()=>{
 const start=()=>{
   const home=document.getElementById('il9');
   const reduced=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
   if(home&&!home.dataset.il12Ready){
     home.dataset.il12Ready='1';
     const stages=home.querySelectorAll('[data-il12-rotor]');
     for(const stage of stages){
       const els=[...stage.querySelectorAll('[data-il12-view]')];
       const prev=stage.querySelector('[data-il12-prev]'),next=stage.querySelector('[data-il12-next]'),toggle=stage.querySelector('[data-il12-pause]');
       const names=['FRONT','THREE-QUARTER','SIDE','BACK'];
       const status=stage.querySelector('[data-il12-current-title]');
       const count=stage.querySelector('.il12-current-count');
       const progress=stage.querySelector('[data-il12-progress]');
       let active=0,timer=null,visible=false,manualPaused=reduced;
       let hover=false;
       const repaint=()=>{
         els.forEach((el,i)=>{
           const rel=(i-active+els.length)%els.length;
           const slot=rel===0?'active':rel===1?'next':rel===els.length-1?'previous':'hidden';
           el.dataset.slot=slot;el.setAttribute('aria-pressed',String(rel===0));
           el.tabIndex=(slot==='hidden')?-1:0;
         });
         if(status)status.textContent=names[active]+' / '+String(active+1).padStart(2,'0');
         if(count)count.innerHTML=String(active+1).padStart(2,'0')+' <i>/</i> 04';
       };
       const timerStop=()=>{if(timer!==null){clearInterval(timer);timer=null;}if(progress)progress.style.animationPlayState='paused';};
       const timerStart=()=>{
         timerStop();const play=visible&&!manualPaused&&!hover&&!document.hidden&&!reduced;
         stage.classList.toggle('is-paused',!play);
         if(toggle){toggle.textContent=manualPaused?'▶':'Ⅱ';toggle.setAttribute('aria-pressed',String(manualPaused));toggle.setAttribute('aria-label',manualPaused?'Resume garment animation':'Pause garment animation');}
         if(!play)return;
         if(progress){progress.style.animation='none';void progress.offsetWidth;progress.style.animation='';progress.style.animationPlayState='running';}
         timer=setInterval(()=>{active=(active+1)%els.length;repaint();if(progress){progress.style.animation='none';void progress.offsetWidth;progress.style.animation='';}},4400);
       };
       const turn=(value,user)=>{active=(value+els.length)%els.length;repaint();if(user)timerStart();};
       els.forEach((el,i)=>el.addEventListener('click',()=>turn(i,true)));
       prev?.addEventListener('click',()=>turn(active-1,true));next?.addEventListener('click',()=>turn(active+1,true));
       toggle?.addEventListener('click',()=>{manualPaused=!manualPaused;timerStart();});
       const rotor=stage.querySelector('.il12-rotor-space');
       rotor?.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();turn(active+(e.key==='ArrowRight'?1:-1),true);}});
       stage.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hover=true;timerStart()}});
       stage.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hover=false;timerStart()}});
       stage.addEventListener('focusin',()=>{hover=true;timerStart()});
       stage.addEventListener('focusout',e=>{if(!stage.contains(e.relatedTarget)){hover=false;timerStart()}});
       if('IntersectionObserver'in window){const io=new IntersectionObserver(entries=>{for(const e of entries){visible=e.isIntersecting;timerStart();}},{threshold:.2});io.observe(stage);}else{visible=true;timerStart();}
       document.addEventListener('visibilitychange',timerStart);
       repaint();
     }
     if(!reduced&&window.matchMedia('(hover:hover) and (pointer:fine)').matches){
       const hero=home.querySelector('.il9-stage-hero');
       if(hero){let raf=0,px=0,py=0;const set=()=>{hero.style.setProperty('--il12-pointer-x',px+'px');hero.style.setProperty('--il12-pointer-y',py+'px');raf=0;};hero.addEventListener('pointermove',e=>{const b=hero.getBoundingClientRect();px=+((e.clientX-b.left)/b.width-.5)*16;py=+((e.clientY-b.top)/b.height-.5)*10;if(!raf)raf=requestAnimationFrame(set)});hero.addEventListener('pointerleave',()=>{px=0;py=0;if(!raf)raf=requestAnimationFrame(set)});}
     }
   }
   const interior=document.getElementById('ilp');
   if(interior&&!interior.dataset.il12Ready){
     interior.dataset.il12Ready='1';
     if(!reduced){
       const hero=interior.querySelector('.ilp-hero');
       if(hero&&window.matchMedia('(hover:hover) and (pointer:fine)').matches){let raf=0;hero.addEventListener('pointermove',e=>{if(raf)return;raf=requestAnimationFrame(()=>{const r=hero.getBoundingClientRect();hero.style.setProperty('--il12-x',(((e.clientX-r.left)/r.width-.5)*12).toFixed(1)+'px');hero.style.setProperty('--il12-y',(((e.clientY-r.top)/r.height-.5)*7).toFixed(1)+'px');raf=0})});hero.addEventListener('pointerleave',()=>{hero.style.removeProperty('--il12-x');hero.style.removeProperty('--il12-y')})}
     }
   }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();